<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
import { getuserBrowse } from '@/api/homeindex'
export default {
  name: 'App',
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
		token: state => state.member.token,
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
	 
	  // 记录浏览（首次加载）
	     // this.$nextTick(() => {
	     //   this.userBrowse()
	     // })
	 
	     // 路由切换时记录
	     this.$router.afterEach(() => {
	       this.userBrowse()
	     })
	 
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
	 // 浏览记录
	 userBrowse:function(){
		 const route = this.$route;
		 const fullPath = route.fullPath;
		 const path = route.path  
		 let pages = 99;
		 if(path == '/home/index'){
		 	pages = 1
		 }
		 if(path == '/home/goodsdetail'){
		 	pages = 2
		 }
		 if(path == '/home/storedetail'){
		 	pages = 3
		 }
		 if(path == '/home/search'){
		 	pages = 4
		 }
		 if(path == '/home/storelist'){
		 	pages = 5
		 }
		 if(path == '/home/memberlogin'){
		 	pages = 8
		 }
		 if(!this.token){
			 this.token="";
		 }
		 
		 
		 
		 // 2026年9月14日之后需要强制登录
		 const targetDate = new Date('2027-02-20');
		 const currentDate = new Date();
		 const needForceLogin = currentDate >= targetDate;
		 if(needForceLogin && pages==3){
			 // 店铺首页，在强制登录才能看店铺的情况下，有用户ID才记录
			 if(this.token){
				getuserBrowse(pages,fullPath,this.token).then((res) => {
					
				}) 
			 }
		 }else{
			 getuserBrowse(pages,fullPath,this.token).then((res) => {
			 	
			 })
		 }
		 

		 
		 
	 }
  }
}
</script>
